import { useMemo } from 'react';

import { Event } from 'store/api/event';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import {
  clearSelectedDevice,
  selectDeviceForEvent,
} from 'store/slices/clover-devices';

export const useSelectedCloverDevice = (event?: Event) => {
  const eventId = event?.id;
  const dispatch = useAppDispatch();

  const selectedDeviceId = useAppSelector((state) =>
    eventId ? selectDeviceForEvent(eventId)(state) : null
  );

  const selectedDevice = useMemo(() => {
    if (!event?.cloverDevices?.length) {
      return null;
    }

    if (selectedDeviceId) {
      const device = event.cloverDevices.find((d) => d.id === selectedDeviceId);
      if (device) {
        return device;
      }
      if (eventId) {
        dispatch(clearSelectedDevice(eventId));
      }
    }

    return event.cloverDevices[0];
  }, [event?.cloverDevices, selectedDeviceId, eventId, dispatch]);

  const deviceOptions = useMemo(() => {
    if (!event?.cloverDevices?.length) {
      return [];
    }
    return event.cloverDevices.map((device) => ({
      value: device.id || '',
      label: device.name || '',
    }));
  }, [event?.cloverDevices]);

  return {
    deviceOptions,
    selectedDevice,
    selectedDeviceId: selectedDevice?.id,
  };
};
